import { createSlice, PayloadAction } from "@reduxjs/toolkit"

const initialState: { value: string[] } = {
  value: []
}

const clientConnectedSlice = createSlice({ 
  name: "client_connected_slice",
  initialState,
  reducers: {
    merge: (state, action: PayloadAction<string[]>) => {
      state.value = action.payload.filter(i => !state.value.includes(i)).concat(state.value)
    },
    pop: (state, action: PayloadAction<string[]>) => {
      state.value = action.payload
    }
  }
})

export const { merge, pop } = clientConnectedSlice.actions
export const client_connected_slice = clientConnectedSlice.reducer